import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["ApiPostLoadMaster"], { status: $setup.status }, {
    beforeRequest: _withCtx(() => [
      _createVNode($setup["CommunityTalkNice"], {
        "is-posted": false,
        "nice-count": $props.niceCount,
        "is-postable": $setup.isPostable,
        onOnClickNice: $setup.post,
        "word-settings": $setup.wordSettings
      }, null, 8 /* PROPS */, ["nice-count", "is-postable", "word-settings"])
    ]),
    afterApiSuccess: _withCtx(() => [
      _createVNode($setup["CommunityTalkNice"], {
        "is-posted": true,
        "nice-count": $props.niceCount,
        "is-postable": $setup.isPostable,
        "word-settings": $setup.wordSettings
      }, null, 8 /* PROPS */, ["nice-count", "is-postable", "word-settings"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["status"]))
}